import Vue from "vue";
import Vuex from "vuex";
import ApiService from "@/services/api-service";
import createOidcStoreModule from "@/config/oidc/create-oidcstore-module";
import { oidcSettings } from "@/config/oidc/open-id-connect-configuration";
import clientsStore from "@/store/modules/clients.module";
import apiresourcesStore from "@/store/modules/apiresources.module";
import identityresourcesStore from "@/store/modules/identityresources.module";
import usersStore from "@/store/modules/users.module";
import rolesStore from "@/store/modules/roles.module";
import loadingStore from "@/store/modules/loader.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    oidcStore: createOidcStoreModule(
      oidcSettings,
      {
        namespaced: true,
        dispatchEventsOnWindow: true
      },
      {
        userLoaded: user => {
          ApiService.setHeader(user.access_token);
          // console.log('OIDC user is loaded:', user)
        }

        /* userUnloaded: () => console.log('OIDC user is unloaded'),
				accessTokenExpiring: () => console.log('Access token will expire'),
				accessTokenExpired: () => console.log('Access token did expire'),
				silentRenewError: () => console.log('OIDC user is unloaded'),
				userSignedOut: () => console.log('OIDC user is signed out'),
				oidcError: payload => console.log('OIDC error', payload) */
      }
    ),
    clientsStore,
    apiresourcesStore,
    identityresourcesStore,
    usersStore,
    rolesStore,
    loadingStore
  }
});
